import { ArrowUpRight, Lightning } from "@phosphor-icons/react";

const SITES = [
  { label: "yellowthinking.com", href: "https://www.yellowthinking.com", tag: "Parent group", testId: "yt-link-yellow" },
  { label: "fasterbetter.ca", href: "https://www.fasterbetter.ca", tag: "Speed audits", testId: "yt-link-faster" },
  { label: "webcoders.ca", href: "https://www.webcoders.ca", tag: "Custom builds", testId: "yt-link-webcoders" },
];

/**
 * Compact "Powered by Yellow Thinking" badge.
 * Renders a small pill button. Hovering / focusing reveals a popover with
 * the three sister-site links — purely CSS, no library dependency.
 * Designed for in-app shells (sidebar / topbar) where the brand is already
 * Auditor and we want a soft cross-sell.
 */
export default function PoweredByBadge({ variant = "light" }) {
  const isDark = variant === "dark";
  return (
    <div className="relative group inline-block" data-testid="powered-by-badge">
      <button
        type="button"
        aria-haspopup="true"
        data-testid="powered-by-trigger"
        className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-sm border text-[10px] tracking-wider font-semibold mono transition-colors ${
          isDark
            ? "border-white/20 text-white/70 hover:border-white/50 hover:text-white bg-white/5"
            : "border-border text-ink-muted hover:border-ink hover:text-ink bg-white"
        }`}
      >
        <Lightning size={11} weight="fill" className="text-brand" />
        POWERED BY YELLOW THINKING
      </button>

      <div
        role="menu"
        data-testid="powered-by-popover"
        className="absolute bottom-full left-0 mb-2 w-64 opacity-0 invisible translate-y-1 group-hover:opacity-100 group-hover:visible group-hover:translate-y-0 group-focus-within:opacity-100 group-focus-within:visible group-focus-within:translate-y-0 transition-all duration-200 z-50"
      >
        <div className="bg-white border border-ink rounded-sm hard-shadow-sm p-3">
          <div className="label-overline mb-2 text-ink">Sister sites</div>
          <ul className="space-y-1">
            {SITES.map((s) => (
              <li key={s.href}>
                <a
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={s.testId}
                  className="flex items-center justify-between gap-2 px-2 py-1.5 rounded-sm hover:bg-secondary group/link transition-colors"
                >
                  <div className="min-w-0">
                    <div className="text-sm font-semibold text-ink truncate">{s.label}</div>
                    <div className="text-[10px] text-ink-muted">{s.tag}</div>
                  </div>
                  <ArrowUpRight size={14} className="text-ink-muted group-hover/link:text-brand transition-colors shrink-0" weight="bold" />
                </a>
              </li>
            ))}
          </ul>
          <div className="mt-3 pt-2 border-t border-border text-[10px] text-ink-muted mono leading-snug">
            Division of <a href="https://www.yellowthinking.com" target="_blank" rel="noopener noreferrer" className="text-ink hover:text-brand underline-offset-2 hover:underline">Yellow Thinking</a>
          </div>
        </div>
      </div>
    </div>
  );
}
